import template from "./smart-registration-add-debitcard.html"

(function ($, ko) {

    ko.components.register('smart-registration-add-debitcard', {
        template: template,
        viewModel: {
            createViewModel: function (params, componentInfo) {
                return new SmartRegistrationAddDebitCard(params, updateContainerHeight(componentInfo.element));
            }
        }
    });

    function SmartRegistrationAddDebitCard(params, updateHeight) {
        const self = this;
        self.addDebitCardRequest = new $.cdh.post.smartRegistration.addDebitCard();
        self.isCardNumberInvalid = ko.observable(false);
        self.isErrorMsgDisplayedForCard = ko.observable(false);
        self.isValidationActivated = ko.observable(false);

        self.model = {
            cardNumber: ko.observable().extend({ required: true, cardType: true })
        };

        self.rawCardNumber = ko.observable('');

        self.validation = new $.cdh.validation(self.model);

        document.getElementById('togglePassword').addEventListener('click', function () {
            const passwordField = document.getElementById('debit_card');
            const eyeIcon = this.querySelector('img');

            if (passwordField.type === 'password') {
                passwordField.type = 'text';
                eyeIcon.src = '/Images/icons/eye-open.svg'; // Change to closed eye icon
            } else {
                passwordField.type = 'password';
                eyeIcon.src = '/Images/icons/eye-closed.svg'; // Change to open eye icon
            }
        });

        self.formattedCardNumber = function (vm, e) {
            var rawValue = vm.model.cardNumber() || "";

            var digits = rawValue.replace(/\D/g, '');
            vm.rawCardNumber(digits);

            var formattedValue = digits.replace(/(.{4})/g, '$1 ').trim();
            vm.model.cardNumber(formattedValue);
        };

        function maskCardNumber(rawDigits) {
            let digits = (rawDigits || '').replace(/\D/g, '');

            if (digits.length <= 10) {
                return digits;
            }

            let masked =
                digits.substring(0, 6) +
                "*".repeat(digits.length - 10) +
                digits.substring(digits.length - 4);

            return masked.replace(/(.{4})/g, '$1').trim();
        }

        self.ensureNumberical = function (data, e) {
            var keyValue = e.key;
            if (keyValue.match(/[0-9]/g)) {
                return true;
            }
            return false;
        }

        self.isLoading = ko.pureComputed(function () {
            return self.addDebitCardRequest.isLoading();
        });

        self.model.cardNumber.subscribe(function (newValue) {
            var digits = (newValue || '').replace(/\D/g, '');
            if (!digits) {
                if (self.isValidationActivated()) {
                    self.isCardNumberInvalid(true);
                    self.isErrorMsgDisplayedForCard(true);
                } else {
                    self.isCardNumberInvalid(false);
                    self.isErrorMsgDisplayedForCard(false);
                }
                return;
            } else {
                self.isValidationActivated(true);
            }
            var isValid = ko.validation.rules.cardType.validator(digits);
            self.isCardNumberInvalid(!isValid);
            self.isErrorMsgDisplayedForCard(!isValid);
        });

        self.back = params.model.onBack;
        self.cancel = params.model.onCancel;

        self.submit = function () {
            if (self.isLoading())
                return;

            self.validation.activate();
            self.isValidationActivated(true);

            var uiValue = self.model.cardNumber() || '';
            var rawDigits = uiValue.replace(/\D/g, '');
            self.rawCardNumber(rawDigits);

            if (!rawDigits) {
                self.isCardNumberInvalid(true);
                self.isErrorMsgDisplayedForCard(true);
                return;
            }

            var isValidCard = ko.validation.rules.cardType.validator(rawDigits);

            if (!isValidCard || self.validation.hasErrors()) {
                self.isCardNumberInvalid(true);
                self.isErrorMsgDisplayedForCard(true);
                return;
            }

            self.isCardNumberInvalid(false);
            self.isErrorMsgDisplayedForCard(false);

            self.sendData(rawDigits);
        };

        self.sendData = function (rawDigits) {
            let payload = {
                cardNumber: maskCardNumber(rawDigits)
            };

            return self.addDebitCardRequest.load(payload)
                .done(function (result) {
                    params.model.onNext(result);
                })
                .fail(function () {
                    recalcWidgetsHeights();
                    updateHeight();
                });
        };

        params.model.clear = function () {
            self.model.cardNumber('');
            self.rawCardNumber('');
            self.validation.deactivate(true);
            self.addDebitCardRequest.setData(null);
            self.isValidationActivated(false);
            self.isCardNumberInvalid(false);
            self.isErrorMsgDisplayedForCard(false);
        };
    }

})(jQuery, ko);